// Presentation formatting — Polish locale, ported from the prototype's data.js.
// Accepts Date (the API returns Date objects), ISO strings, or epoch millis.

const DAY = 864e5;

type DateInput = Date | string | number;
function toDate(v: DateInput): Date {
  return v instanceof Date ? v : new Date(v);
}

/** "2 200 zł" — whole złoty, mono+tabular at the call site. */
export const fmtZl = (n: number): string => `${Math.round(n).toLocaleString('pl-PL')} zł`;

/** Call timer "m:ss". */
export const fmtDur = (sec: number): string => {
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
};

/** Aggregate minutes "X min" / "Y h Z min". */
export const fmtMin = (sec: number): string => {
  const m = Math.round(sec / 60);
  if (m < 60) return `${m} min`;
  const h = Math.floor(m / 60);
  return `${h} h ${m % 60} min`;
};

/** Absolute date "dd.mm.yyyy". */
export const fmtDate = (v: DateInput): string => {
  const d = toDate(v);
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
};

/** Relative date used in activity feeds: dziś / wczoraj / N dni temu / absolute. */
export const relDate = (v: DateInput): string => {
  const days = Math.floor((Date.now() - toDate(v).getTime()) / DAY);
  if (days <= 0) return 'dziś';
  if (days === 1) return 'wczoraj';
  if (days < 30) return `${days} dni temu`;
  return fmtDate(v);
};

/** Payback months "1,3 mc" (Polish decimal comma) or em dash. */
export const fmtPayback = (p: number | null | undefined): string =>
  p != null ? `${p.toFixed(1).replace('.', ',')} mc` : '—';
